import {LitElement, html, css, svg} from 'lit';
import {customElement, property} from 'lit/decorators.js';

@customElement('obi-buoy-conical-cross')
export class ObiBuoyConicalCross extends LitElement {
  @property({type: Boolean}) useCssColor = false;

  private icon = svg`<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M6.67286 18.5001H5V20.0001H9C9 21.6569 10.3431 23.0001 12 23.0001C13.6569 23.0001 15 21.6569 15 20.0001H19V18.5001H17.2639C17.118 17.8091 16.882 16.8368 16.5 15.5C15.6505 12.5266 14 9.99995 14 9.99995C14 9.99995 10.5455 10.9316 8.5 13.9999C7.38432 15.6736 6.89099 17.3473 6.67286 18.5001ZM14.5986 18.4999H15.7288C15.5883 17.8729 15.3765 17.0278 15.0577 15.912C14.6697 14.5538 14.091 13.2753 13.599 12.3239C13.512 12.1557 13.4283 11.9987 13.3495 11.8544C13.162 11.9416 12.957 12.0441 12.7407 12.1632C11.7553 12.7059 10.5958 13.5604 9.7481 14.832C8.87506 16.1416 8.43486 17.458 8.21432 18.4504L8.20342 18.4999H9.40142C9.92015 17.6033 10.8896 17.0001 12 17.0001C13.1104 17.0001 14.0799 17.6033 14.5986 18.4999ZM13.5 20.0001C13.5 20.8285 12.8284 21.5001 12 21.5001C11.1716 21.5001 10.5 20.8285 10.5 20.0001C10.5 19.1716 11.1716 18.5001 12 18.5001C12.8284 18.5001 13.5 19.1716 13.5 20.0001Z" fill="currentColor"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M15.891 5.75007L15.2236 8.19741L13.7764 7.80273L14.3362 5.75007L12 5.75007V4.25007L14.7453 4.25007L15.2764 2.30273L16.7236 2.69741L16.3001 4.25007L19 4.25007V5.75007L15.891 5.75007Z" fill="currentColor"/>
</svg>
`;

  private iconCss = svg`<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M6.67286 18.5001H5V20.0001H9C9 21.6569 10.3431 23.0001 12 23.0001C13.6569 23.0001 15 21.6569 15 20.0001H19V18.5001H17.2639C17.118 17.8091 16.882 16.8368 16.5 15.5C15.6505 12.5266 14 9.99995 14 9.99995C14 9.99995 10.5455 10.9316 8.5 13.9999C7.38432 15.6736 6.89099 17.3473 6.67286 18.5001ZM14.5986 18.4999H15.7288C15.5883 17.8729 15.3765 17.0278 15.0577 15.912C14.6697 14.5538 14.091 13.2753 13.599 12.3239C13.512 12.1557 13.4283 11.9987 13.3495 11.8544C13.162 11.9416 12.957 12.0441 12.7407 12.1632C11.7553 12.7059 10.5958 13.5604 9.7481 14.832C8.87506 16.1416 8.43486 17.458 8.21432 18.4504L8.20342 18.4999H9.40142C9.92015 17.6033 10.8896 17.0001 12 17.0001C13.1104 17.0001 14.0799 17.6033 14.5986 18.4999ZM13.5 20.0001C13.5 20.8285 12.8284 21.5001 12 21.5001C11.1716 21.5001 10.5 20.8285 10.5 20.0001C10.5 19.1716 11.1716 18.5001 12 18.5001C12.8284 18.5001 13.5 19.1716 13.5 20.0001Z" style="fill: var(--element-active-color)"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M15.891 5.75007L15.2236 8.19741L13.7764 7.80273L14.3362 5.75007L12 5.75007V4.25007L14.7453 4.25007L15.2764 2.30273L16.7236 2.69741L16.3001 4.25007L19 4.25007V5.75007L15.891 5.75007Z" style="fill: var(--element-active-color)"/>
</svg>
`;

  override render() {
    return html`
      <div class="wrapper">${this.useCssColor ? this.iconCss : this.icon}</div>
    `;
  }

  static override styles = css`
    .wrapper {
      height: 100%;
      width: 100%;
      line-height: 0;
    }
    .wrapper > * {
      height: 100%;
      width: 100%;
    }
  `;
}

declare global {
  interface HTMLElementTagNameMap {
    'obi-buoy-conical-cross': ObiBuoyConicalCross;
  }
}
